import { gql } from '@apollo/client';

const tasksDueNotificationBaseFragment = gql`
  fragment TasksDueNotificationBaseFields on TasksDueNotificationBase {
    Type
    DueDate
  }
`;

export default tasksDueNotificationBaseFragment;
